<template lang="pug">
  
</template>

<script>
export default {
  name: 'UpGrade',
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang='less' scoped>

</style>


// WEBPACK FOOTER //
// src/UIO/DiaLog/UpGrade/App.vue